import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import useNotificationsStore from "../api/store";
import { useMarkAllReadStatus } from "../api/hooks";
import { commonButtonProps } from "../../../common/components/buttons/sxprops";
import { cancelButton } from "../sxprops";

export const ConfirmMarkAllReadDialog: React.FC = () => {
  const notifStore = useNotificationsStore();

  const { mutate: updateReadStatus } = useMarkAllReadStatus();

  const handleCancel = () => {
    notifStore.setshowMarkReadDialog(false);
    notifStore.setSelectedNotifId("");
    notifStore.setNotifsToMark([]);
  };

  const handleConfirm = () => {
    const ids = notifStore.notifsToMark.map((n) => n.id);
    const isRead = !notifStore.isAllMarkedRead;
    notifStore.setIsAllMarkedRead(!notifStore.isAllMarkedRead);
    updateReadStatus({ ids, isRead });
  };

  const notificationCount = notifStore.isAllMarkedRead
    ? notifStore.notifsToMark.filter((n) => n.isRead).length
    : notifStore.notifsToMark.filter((n) => !n.isRead).length;

  const titleText = notifStore.isAllMarkedRead
    ? "Mark All as Unread"
    : "Mark All as Read";

  const confirmQuestion = notifStore.isAllMarkedRead
    ? "Are you sure you want to mark all of them as unread?"
    : "Are you sure you want to mark all of them as read?";

  return (
    <Dialog
      open={notifStore.showMarkReadDialog}
      onClick={handleCancel}
      aria-labelledby="confirm-delete-title"
      maxWidth={false}
      fullWidth={false}
      PaperProps={{
        sx: {
          width: 645,
          height: 235,
          borderRadius: 4,
          p: 0,
        },
      }}
    >
      <DialogTitle id="confirm-delete-title" color="#123257" fontWeight={600}>
        {titleText}
        <Typography variant="body2" color="textSecondary" paddingTop={1.5}>
          You have <strong>{notificationCount}</strong>{" "}
          {notifStore.isAllMarkedRead ? "read" : "unread"} notification
          {notificationCount !== 1 ? "s" : ""}.
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ px: 3, overflowY: "hidden" }}>
        <Typography variant="body2" color="textSecondary">
          {confirmQuestion}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          This action will update their status, but you can still view them in
          your notification list.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleCancel}
          sx={cancelButton}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{ ...commonButtonProps, width: "105px" }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
